var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastMessageCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#828283",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M295.797 72.055h-2.071l-.304-.506c-.68-1.135-1.907-1.829-3.23-1.829s-2.548.694-3.23 1.829l-.303.506h-2.07c-1.033 0-1.869.837-1.869 1.868v7.473c0 1.031.836 1.868 1.868 1.868h11.209c1.031 0 1.868-.837 1.868-1.868v-7.473c0-1.031-.837-1.868-1.868-1.868zm-5.605 8.874c-1.805 0-3.269-1.464-3.269-3.27 0-1.805 1.464-3.269 3.27-3.269 1.805 0 3.269 1.464 3.269 3.27 0 .866-.345 1.698-.958 2.311s-1.445.958-2.312.958z",
    transform: "translate(-270 -429) translate(-12 360)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastMessageCamera);
export default __webpack_public_path__ + "static/media/lastMessageCamera.b90acb55b27d5abf3e8e483d73c90ce3.svg";
export { ForwardRef as ReactComponent };